export const CONTACT = {
  coach: "Ryan Mitchell",
  email: "mitchellr@norwalkps.org",
  phone: "(203) 984-1955",
  school: "Norwalk High School",
  address: "55 County St, Norwalk, CT 06851",
  field: "Malmquist Field",
};

export const NAV_LINKS = [
  { label: "Home", path: "/", testid: "nav-link-home" },
  { label: "Schedule", path: "/schedule", testid: "nav-link-schedule" },
  { label: "Roster", path: "/roster", testid: "nav-link-roster" },
  { label: "Coaches", path: "/coaches", testid: "nav-link-coaches" },
  { label: "Bears in College", path: "/college", testid: "nav-link-college" },
  { label: "Records", path: "/records", testid: "nav-link-records" },
  { label: "Gallery", path: "/gallery", testid: "nav-link-gallery" },
  { label: "About", path: "/about", testid: "nav-link-about" },
  { label: "Contact", path: "/contact", testid: "nav-link-contact" },
];

export const SITE_CONTENT = {
  team_name: "Norwalk Bears Baseball",
  logo_url: "/assets/bears-logo.jpeg",
  hero_kicker: "Norwalk High School · Norwalk, CT",
  hero_title: "Bears\nBaseball",
  hero_subtitle: "Building successful student-athletes on and off the field — through commitment, grit, discipline, and community.",
  hero_image: "/assets/team-field.jpeg",
  mission_title: "Build Successful Student-Athletes",
  mission_text: "Norwalk Bears Baseball is about more than wins and losses. We develop young men who compete hard, carry themselves with integrity, take care of the classroom, and give back to the Norwalk community — from FCIAC Friday nights to reading with elementary students at Tracey Magnet.",
  about_story_1: "Baseball runs deep in Norwalk. The Bears program carries that tradition forward at Norwalk High School — competing in the FCIAC, one of the toughest conferences in Connecticut, and representing the city with pride every spring.",
  about_story_2: "Under Head Coach Ryan Mitchell, the program measures success by more than the scoreboard: players who grow as students, teammates, and members of the Norwalk community. That is what it means to build successful student-athletes.",
  community_title: "Bears Give Back",
  community_text: "Bears players regularly visit Norwalk elementary schools — reading to students during Read Across America and serving as guest mentors. In 2026, Josh Todd and Jaiden Singh earned Character Partnership recognition from Tracey Magnet School for their work with young readers.",
  footer_text: "Building successful student-athletes on and off the field at Norwalk High School.",
  contact_coach: "Ryan Mitchell",
  contact_email: "mitchellr@norwalkps.org",
  contact_phone: "(203) 984-1955",
  contact_school: "Norwalk High School",
  contact_address: "55 County St, Norwalk, CT 06851",
  field_name: "Malmquist Field",
  social_instagram: "",
  social_twitter: "",
  social_facebook: "",
  featured_news_id: "",
  subtitle_schedule: "Game dates, times, opponents, locations, and final scores for the Norwalk Bears varsity squad.",
  subtitle_roster: "Varsity players — jersey numbers, positions, class years, and batting/throwing hands.",
  subtitle_coaches: "Experienced, player-first leadership committed to developing Bears on the field, in the classroom, and in the community.",
  subtitle_college: "Former Bears who have gone on to play baseball at the college level — once a Bear, always a Bear.",
  subtitle_records: "Championships, records, awards, and milestones from Norwalk Bears Baseball history.",
  subtitle_gallery: "Game action, team events, and community moments — photos and highlight videos from around the program.",
  subtitle_about: "A tradition of baseball in Norwalk — built on developing successful student-athletes, not just ballplayers.",
  subtitle_contact: "Questions about tryouts, schedules, or the program? Reach out — Coach Mitchell reads every message.",
};

export const VALUES = [
  { title: "Discipline", text: "Showing up early, doing the work, and holding ourselves to a standard every single day." },
  { title: "Integrity", text: "Playing the game the right way and representing Norwalk with pride on and off the field." },
  { title: "Academics First", text: "Student comes before athlete. Classroom accountability is a condition of wearing the uniform." },
  { title: "Teamwork", text: "Nine players, one heartbeat. We win together and we pick each other up." },
  { title: "Perseverance", text: "Baseball is a game of failure. Bears respond, adjust, and compete the next pitch." },
];

export const recordFor = (games, level) => {
  const list = games.filter((g) => g.level === level);
  const w = list.filter((g) => g.wl === "W").length;
  const l = list.filter((g) => g.wl === "L").length;
  return { w, l };
};

export const gradeLabel = (g) => ({ 9: "Freshman", 10: "Sophomore", 11: "Junior", 12: "Senior" }[g] || g);

export const formatDate = (iso) => {
  if (!iso) return "";
  if (!/^\d{4}-\d{2}-\d{2}/.test(iso)) return iso;
  return new Date(iso.slice(0, 10) + "T12:00:00").toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
};
